var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('pt-health-record-detail',{staticClass:"pt-health-record-detail__withData",attrs:{"id":_vm.id,"healthRecordDetail":_vm.healthRecordDetail}})}
var staticRenderFns = []

export { render, staticRenderFns }